import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

const Login = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      setIsLoggedIn(true);
      navigate("/Edityourblogs");
    }
  }, [navigate, setIsLoggedIn]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://blog-backend-ivfv.onrender.com/superadmin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        setIsLoggedIn(true);
        navigate("/Edityourblogs"); // Redirect to superadmin dashboard
      } else if (response.status === 401 && data.error === "Token expired") {
        // Handle token refresh
        const refreshToken = localStorage.getItem("refreshToken");
        const refreshResponse = await fetch(
          "https://blog-backend-ivfv.onrender.com/refresh-token",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ refreshToken }),
          }
        );

        if (refreshResponse.ok) {
          const refreshedData = await refreshResponse.json();
          localStorage.setItem("accessToken", refreshedData.accessToken);
          setIsLoggedIn(true);
          navigate("/Edityourblogs");
        } else {
          setError("Session expired. Please login again.");
        }
      } else {
        setError(data.error);
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError("Internal Server Error");
    }
  };

  return (
    <div className="auth-container">
      <h2>Login (SuperAdmin)</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit} className="auth-form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;
